<h1 mat-dialog-title
  class="draggable-dialogue-header"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle>
  Bulk Workflow Update
</h1>
@if (NgFormGroup) {
  <form class="form" mat-dialog-content (ngSubmit)="onSave()" matForm [formGroup]="NgFormGroup">
    <br />
    @if (!TransitionCompleted || TransitionedFormInstances.length > 0) {
      <div>
        <div class="guidance">Use this dialog to transition the selected forms from one workflow stage to another.</div>
        <div class="guidance guidance-black">If none of the selected forms can be transitioned based on the below selection, you will see a message that indicates no forms were transitioned.</div>
        <br />
      </div>
    }
    @if (!TransitionCompleted) {
      <div>
        @if (!this.UserWorkflowTransitions || this.UserWorkflowTransitions.length == 0) {
          <div>
            No workflow transitions available for the selected forms.
          </div>
        }
        @if (this.UserWorkflowTransitions?.length > 0) {
          <mat-form-field appearance="outline" [floatLabel]="'always'" class="select">
            <mat-label>Workflow Transition</mat-label>
            <mat-select formControlName="transitionSelect" [(ngModel)]="SelectedWorkflowTransitionId">
              <ng-container>
                <mat-option [value]="-1">-- Choose a Workflow Transition--</mat-option>
                @for (t of this.UserWorkflowTransitions; track t) {
                <mat-option [value]="t.workflowTransitionId">
                    @if (t.bulkWorkflowName) {
                        {{t.bulkWorkflowName}}
                    }
                    @else {
                        {{t.workflowTransitionName}}
                        ({{t.startWorkflowState}} to {{t.endWorkflowState}})
                    }
                </mat-option>
                }
              </ng-container>
            </mat-select>
          </mat-form-field>
        }
      </div>
    }
    @if (TransitionCompleted) {
      <div>
        @if (TransitionedFormInstances && TransitionedFormInstances.length == 0) {
          <div>
            No form instances were found for the selected transition - no forms were transitioned.
          </div>
        }
        @if (TransitionedFormInstances && TransitionedFormInstances.length > 0) {
          <div>
            @if (TransitionedFormInstances.length == 1) {
              <span>Transition applied to form instance:</span>
            }
            @if (TransitionedFormInstances.length > 1) {
              <span>Transition applied to {{TransitionedFormInstances.length}} form instances:</span>
            }
            <br />
            <div class="fi-list">
              <ul>
                @for (tfi of TransitionedFormInstances; track tfi) {
                  <li>{{tfi.name}}</li>
                }
              </ul>
            </div>
          </div>
        }
      </div>
    }
  </form>
}
<div mat-dialog-actions>
  @if (!TransitionCompleted) {
    <button mat-flat-button color="primary" class="theme-primary-btn" (click)="onSave()" [disabled]="OKDisabled">OK</button>
  }
  @if (!TransitionCompleted) {
    <button mat-flat-button color="basic" class="form-button-secondary" [mat-dialog-close]="null" style="margin-left: 10px;">Cancel</button>
  }
  @if (TransitionCompleted) {
    <button mat-flat-button color="basic" class="form-button-secondary" [mat-dialog-close]="null" style="margin-left: 10px;">Close</button>
  }
</div>
